<button (click)="onToggleExpandOptions()" id="actionButtonMultiple" [innerHTML]="icon" class="floating-button" [ngClass]="{'inPopUp' : expandOptions}"></button>
<div class="multiple-actions-overlay" *ngIf="expandOptions">
  <div class="multiple-actions-holder">
    <div class="action-button" *ngFor="let actionButton of actionButtons" (click)="onItemClicked(actionButton.callback)">
      <div class="action-button-title" *transloco="let t;">{{ t(actionButton.title) | capitalize }}</div>
      <div class="action-button-icon" [innerHTML]="actionButton.icon"></div>
    </div>
  </div>
</div>
